<template>
    <div>
        <div id="custom-container" ref="containerFlatfile" class="import-step-flatfile" />
    </div>
</template>
<script>
import Env from 'Services/Env';
import { createNamespacedHelpers } from 'vuex';

const importsStore = createNamespacedHelpers('importsStore');
const { mapState: mapStateUser } = createNamespacedHelpers('user');
const { mapState: mapStateCorp } = createNamespacedHelpers('corp');

import { initializeFlatfile } from '@flatfile/javascript';
import { themeConfig } from 'Config/authenticated/imports/ImportThemeConfiguration';

export default {
    data() {
        return {
            publishableKey: Env.get('flatfile').publishableKey,
            apiUrl: Env.get('flatfile').apiUrl,
            spaceId: null,
        };
    },
    computed: {
        ...importsStore.mapGetters({
            metadata: 'getMetadata',
            genericImportMetadata: 'getGenericImportMetadata',
            isImportUnlimited: 'isImportUnlimited',
            nonGoldMaxLines: 'getNonGoldMaxLines',
            dictionaryImportConfig: 'getTypeImport',
            customFields: 'getCustomFields',
        }),
        ...mapStateUser({
            userId: 'id',
            userForename: 'forename',
            userName: 'name',
            uiLang: 'uiLang',
        }),
        ...mapStateCorp({
            corpId: 'id',
            corpName: 'name',
        }),
        getUserName() {
            return `${this.userForename} ${this.userName}`;
        },
    },
    created() {
        this.loadImporter().catch((e) => {
            window.sellsyapp.config.globalProperties.$store.state.system.errorsHandler.logException(
                e,
            );
            this.$pushToast({
                type: 'error',
                text: this.$l10n.__('Erreur de connexion au système, merci de réessayer'),
                close: true,
                unique: true,
                icon: true,
                timeout: 4000,
            });
            this.$emit('onError', true);
        });
    },
    methods: {
        async loadImporter() {
            const url = new URL(window.location);
            const flatfileOptions = {
                name: `${this.dictionaryImportConfig.type} corp#${this.corpId} staff#${this.userId}`,
                publishableKey: this.publishableKey,
                workbook: this.getWorkbook(),
                userInfo: {
                    userId: this.userId,
                    name: this.getUserName,
                    companyId: this.corpId,
                    companyName: this.corpName,
                },
                apiUrl: this.apiUrl,
                themeConfig,
                sidebarConfig: {
                    showSidebar: false,
                },
                displayAsModal: false,
                closeSpace: {
                    operation: 'submitAction',
                    onClose: () => this.$emit('closed'),
                },
                mountElement: 'custom-container',
                languageOverride: this.uiLang,

                translationsPath: `${url.protocol}//${url.host}/imports/locales/${this.uiLang}/translation.json`,
            };
            const { spaceId } = await initializeFlatfile(flatfileOptions);
            this.spaceId = spaceId;
        },
        getWorkbook() {
            const sheets = [
                {
                    name: this.dictionaryImportConfig.title,
                    slug: 'sellsy-import',
                    allowAdditionalFields: false,
                    fields: [...(this.dictionaryImportConfig.fields ?? []), ...this.customFields],
                    access: ['import', 'edit', 'delete'],
                },
            ];

            return {
                name: this.dictionaryImportConfig.title,
                sheets,
                actions: [
                    {
                        operation: 'submitAction',
                        mode: 'foreground',
                        label: this.$l10n.__('Importer'),
                        tooltip: this.$l10n.__('Commencer le transfert de vos données'),
                        primary: true,
                        constraints: [{ type: 'hasData' }, { type: 'hasAllValid' }],
                    },
                ],
                settings: {
                    trackChanges: true,
                },
                metadata: {
                    importType: this.dictionaryImportConfig.type,
                    apiBaseUrl: window.apiHost,
                    metadata: this.metadata,
                    nonGoldMaxLines: this.nonGoldMaxLines,
                    isImportUnlimited: this.isImportUnlimited,
                    messages: {
                        errorMessagePrefix: this.$t.__(
                            'settings.import.ImportFlatfileStep.errorMessagePrefix',
                        ),
                        apiBaseUrlErrorMessage: this.$t.__(
                            'settings.import.ImportFlatfileStep.apiBaseUrlErrorMessage',
                        ),
                        labelLimitedErrorMsg: this.$l10n.__(
                            'En période d’essai, l’import est limité à %(lines)s lignes maximum par fichier.',
                            { lines: this.nonGoldMaxLines },
                        ),
                    },
                    ...this.genericImportMetadata,
                },
            };
        },
    },
};
</script>
<style lang="scss">
.flatfile_iframe-wrapper {
    width: 100% !important ;
    height: 100% !important;
}
</style>
